export const CHANGE_EXPENSES_VERSION = 'CHANGE_EXPENSES_VERSION';
